import { HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { SiaTableInformations } from '../interfaces/sia-table-informations';
import { SiaHttpService } from '../services/http.service';

@Injectable({
  providedIn: 'root',
})
export class SiaComponentApi {
  private http = inject(SiaHttpService);

  private readonly apiController: string = 'component';

  /** Inserted by Angular inject() migration for backwards compatibility */

  constructor() {}

  updateActionGroupId(id: string, actionGroupId: string | null) {
    var p = { id: id, description: actionGroupId };
    return this.http.put(`${this.apiController}/action-group-id`, p);
  }

  getTableInformations(
    componentId: string,
    connectionName: string = 'CoreDB',
  ): Promise<SiaTableInformations[]> {
    let params = new HttpParams();
    params = params.set('componentId', `${componentId}`);
    params = params.set('connectionStringName', `${connectionName}`);

    return this.http.get(`${this.apiController}/table-informations`, {
      params,
    });
  }
  getViewInformations(
    componentId: string,
    connectionName: string = 'CoreDB',
  ): Promise<SiaTableInformations[]> {
    let params = new HttpParams();
    params = params.set('componentId', `${componentId}`);
    params = params.set('connectionStringName', `${connectionName}`);
    return this.http.get(`${this.apiController}/view-informations`, {
      params,
    });
  }
  getViewInformationsByNameAndSchema(
    viewName: string,
    viewSchema: string,
  ): Promise<SiaTableInformations[]> {
    let params = new HttpParams();
    params = params.set('viewName', `${viewName}`);
    params = params.set('viewSchema', `${viewSchema}`);
    return this.http.get(
      `${this.apiController}/view-informations-by-name-and-schema`,
      {
        params,
      },
    );
  }
  getPersistenceProperties(componentId: string) {
    let params = new HttpParams();
    params = params.set('componentId', `${componentId}`);
    return this.http.get(`${this.apiController}/persistance-properties/`, {
      params,
    });
  }
}
